import type { CustomIconProps } from '../CustomIcon';

export const UploadIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  unfilled,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' fill={unfilled ? 'transparent' : color} />
      <path
        d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 8l5-5 5 5M12 3v12'
        stroke={secondaryColor}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
